
import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { Card, CardHeader, CardContent, CardFooter } from './ui/card';

interface ProductCardProps {
  logo: string;
  productImage: string;
  description: string;
  link: string;
  name: string;
}

const ProductCard = ({ logo, productImage, description, link, name }: ProductCardProps) => {
  const isSSLogo = logo.includes("477c79c5-baf2-44c7-a481-a9fb3e2f579a");
  const isPowerIOLogo = logo.includes("f77fbf87-109d-47a4-8090-9c29e7b63a3d");
  const isPowerIOProduct = name === "powerIO®-Box";

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Card className="h-full bg-white border-gray-200">
        <CardHeader className="space-y-4">
          <div className="h-12 flex items-center justify-center">
            <img 
              src={logo} 
              alt={`${name} logo`} 
              className={`h-full object-contain ${isSSLogo ? 'max-w-[300px]' : isPowerIOLogo ? 'max-w-[200px]' : 'max-w-[140px]'}`}
            />
          </div>
          <div className="bg-white rounded-md p-4">
            <img 
              src={productImage} 
              alt={name} 
              className={`w-full ${isPowerIOProduct ? 'h-56' : 'h-48'} object-contain`}
            />
          </div>
        </CardHeader>
        <CardContent>
          <h3 className="text-xl font-semibold text-black mb-2">{name}</h3>
          <p className="text-black">{description}</p>
        </CardContent>
        <CardFooter>
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center hover:opacity-80 transition-opacity"
            style={{ color: '#a7cc00' }}
          >
            Learn More <ExternalLink className="ml-2 h-4 w-4" />
          </a>
        </CardFooter>
      </Card>
    </motion.div>
  );
};

export default ProductCard;
